import React from "react"
import FontAwesome from "react-fontawesome"

export default function RevenueSharingTable({ investorRevenue }) {

  return (
    <table>
      <tbody>
        <tr>
          <td><FontAwesome name='caret-right' className="lime-900" /> Aion Sol</td>
          <td className="px-10">{ 100 - investorRevenue }%</td>
        </tr>
        <tr>
          <td className="pt-10"><FontAwesome name='caret-right' className="lime-900" /> Investor</td>
          <td className="px-10 pt-10">{ investorRevenue }%</td>
        </tr>
      </tbody>
    </table>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/RevenueSharingTable.js